import {
  arrayBuilderItemFirstPageTitleUI,
  addressNoMilitaryUI,
  addressNoMilitarySchema,
  textUI,
} from 'platform/forms-system/src/js/web-component-patterns';
import {
  addressUiSchema,
  trainingProviderArrayOptions,
  addressSpecifications,
} from '../helpers';

const uiSchema = {
  ...arrayBuilderItemFirstPageTitleUI({
    title: 'Training provider name and mailing address',
    nounSingular: trainingProviderArrayOptions.nounSingular,
  }),
  providerName: {
    ...textUI({
      title: 'Name of training provider',
      errorMessages: {
        required:
          'You must provide a response with minimum 3 characters and maximum of 75 characters. Accepted values are alphanumeric characters, apostrophes, commas, periods, spaces, colons, semicolons, and parentheses.',
        minLength:
          'You must provide a response with minimum 3 characters and maximum of 75 characters. Accepted values are alphanumeric characters, apostrophes, commas, periods, spaces, colons, semicolons, and parentheses.',
        pattern:
          'You must provide a response with minimum 3 characters and maximum of 75 characters. Accepted values are alphanumeric characters, apostrophes, commas, periods, spaces, colons, semicolons, and parentheses.',
      },
    }),
    'ui:options': {
      replaceSchema: (formData, schema, _uiSchema, _index, _path, fullData) =>
        formData?.meb93Release ?? fullData?.meb93Release
          ? {
              ...schema,
              pattern: `^(?=(?:\\s*\\S){3,})[A-Za-z0-9;:.', ()-]+$`,
            }
          : schema,
    },
  },
  providerAddress: addressUiSchema({
    baseUiSchema: addressNoMilitaryUI({ omit: ['street3'] }),
    addressKey: 'providerAddress',
  }),
};

const schema = {
  type: 'object',
  required: ['providerName', 'providerAddress'],
  properties: {
    providerName: {
      type: 'string',
      minLength: 3,
      maxLength: 75,
      pattern: `^[A-Za-z0-9;:.', ()-]+$`,
    },
    providerAddress: addressNoMilitarySchema({
      omit: ['street3'],
      extend: {
        street: {
          minLength: addressSpecifications.street.minLength,
          maxLength: addressSpecifications.street.maxLength,
        },
        street2: { maxLength: addressSpecifications.street2.maxLength },
        city: {
          minLength: addressSpecifications.city.minLength,
          maxLength: addressSpecifications.city.maxLength,
        },
        postalCode: {
          minLength: addressSpecifications.postalCode.minLength,
          maxLength: addressSpecifications.postalCode.maxLength,
        },
      },
    }),
  },
};

export { schema, uiSchema };
